import Helper from './Helper';
import Accordion from './Accordion';

class SwitchHandler {
  constructor(config = {}) {
    const {
      swtchSelector,
    } = config;
    this.switchContainerSelector = '.ns-switch-container';
    this.switchSelector = '.ns-switch';
    this.switchToggleSelector = '.ns-switch__toggler';
    this.switchContentSelector = '.ns-switch__content';

    this.switchContainers = Array.prototype.slice.call(document.querySelectorAll(this.switchContainerSelector));

    this.buildSelect();
    // this.bindEvents();
  }

  buildSelect() {
    this.switchContainers.forEach(container => {
      const select = document.createElement('div');
      Helper.addClass(select, 'ns-select-dropdown');
      select.innerHTML = `<div class="ns-select-dropdown__toggle js-switch-select-toggle"></div>
                          <div class="ns-select-dropdown__dropdown"></div>`;
      container.prepend(select);
      const dropdownToggle = container.querySelector('.ns-select-dropdown__toggle');
      const dropdownContent = container.querySelector('.ns-select-dropdown__dropdown');
      const switches = Array.prototype.slice.call(container.querySelectorAll(this.switchSelector));
      switches.forEach((switcher, index) => {
        Helper.addClass(switcher, 'switcher-'+index);
        const toggler = switcher.querySelector(this.switchToggleSelector);
        const content = switcher.querySelector(this.switchContentSelector);
        toggler.setAttribute('data-toggles', 'switcher-'+index);

        if(index == 0){
          Helper.addClass(switcher, 'active');
          Helper.addClass(toggler, 'active');
        }
        const clone = toggler.cloneNode(true)
        dropdownToggle.append(toggler);
        dropdownContent.append(clone);
        this.registerToggle(clone, container);
      });

      new Accordion({ accordions: '.js-switch-select-toggle' });
    });
  }

  registerToggle(toggler, parentContainer) {
    toggler.addEventListener('click', (e) => {
      parentContainer.querySelector('.js-switch-select-toggle').click(); // close select
      const newActiveSwitch = toggler.getAttribute('data-toggles');
      const switches = Array.prototype.slice.call(parentContainer.querySelectorAll(this.switchSelector));
      const toggles = Array.prototype.slice.call(parentContainer.querySelectorAll(this.switchToggleSelector));
      toggles.forEach(toggler => {
        const dataToggles = toggler.getAttribute('data-toggles');
        if(dataToggles == newActiveSwitch){
          Helper.addClass(toggler, 'active');
        } else {
          Helper.removeClass(toggler, 'active');
        }
      });
      switches.forEach(switcher => {
        if(Helper.hasClass(switcher, newActiveSwitch)){
          Helper.slideOpen(switcher, true);
          Helper.addClass(switcher, 'active');
        } else {
          Helper.slideClose(switcher, true);
          Helper.removeClass(switcher, 'active');
        }
      });
    });
  }

}

export default SwitchHandler;
